export const load = () => ({
	title: 'Insulating Double-Pane Windows When They Fail',
	showTitle: true,
});
